import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { SHIP_SLIDES } from "@/data/site";

/*
 * Cinematic hero backdrop: real cargo ships sailing on the open sea, shown from
 * different angles. Each slide crossfades while slowly zooming/panning
 * (Ken Burns), so the ship reads as gliding across the water.
 */
export const HeroSlideshow = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    SHIP_SLIDES.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % SHIP_SLIDES.length);
    }, 6000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden bg-brand-deep">
      <AnimatePresence initial={false}>
        <motion.img
          key={index}
          src={SHIP_SLIDES[index]}
          alt="Cargo ship sailing on the open sea"
          className="absolute inset-0 h-full w-full object-cover"
          initial={{ opacity: 0, scale: 1.12, x: "1.5%" }}
          animate={{ opacity: 1, scale: 1.24, x: "-1.5%" }}
          exit={{ opacity: 0 }}
          transition={{
            opacity: { duration: 1.8, ease: "easeInOut" },
            scale: { duration: 7.5, ease: "linear" },
            x: { duration: 7.5, ease: "linear" },
          }}
        />
      </AnimatePresence>

      {/* slide indicators */}
      <div className="absolute bottom-6 right-8 z-10 hidden sm:flex items-center gap-2">
        {SHIP_SLIDES.map((_, i) => (
          <span
            key={i}
            className={`h-1.5 rounded-full transition-all duration-500 ${
              i === index ? "w-8 bg-white" : "w-3 bg-white/40"
            }`}
          />
        ))}
      </div>
    </div>
  );
};
